(function () {
  const init = (section) => {
    const track = section.querySelector('[data-gh-track]');
    const cards = Array.from(section.querySelectorAll('[data-gh-card]'));
    const dots = Array.from(section.querySelectorAll('[data-gh-dot]'));
    const prev = section.querySelector('[data-gh-prev]');
    const next = section.querySelector('[data-gh-next]');
    const carousel = section.querySelector('[data-gh-carousel]');
    if (!track || cards.length === 0) return;

    const advanceBy = Math.max(1, parseInt(carousel?.dataset.advanceBy || '1', 10) || 1);

    const getCardStep = () => {
      if (cards.length < 2) return cards[0]?.offsetWidth || 0;
      return cards[1].offsetLeft - cards[0].offsetLeft;
    };

    const setActive = (index) => {
      const clamped = Math.max(0, Math.min(cards.length - 1, index));
      dots.forEach((dot, i) => {
        const active = i === clamped;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      if (prev) prev.toggleAttribute('disabled', clamped === 0);
      if (next) next.toggleAttribute('disabled', clamped >= cards.length - 1);
    };

    const scrollToIndex = (index) => {
      const clamped = Math.max(0, Math.min(cards.length - 1, index));
      const target = cards[clamped];
      if (!target) return;
      const trackLeft = track.getBoundingClientRect().left;
      const cardLeft = target.getBoundingClientRect().left;
      const delta = cardLeft - trackLeft;
      track.scrollBy({ left: delta, behavior: 'smooth' });
    };

    const currentIndex = () => {
      const step = getCardStep();
      if (!step) return 0;
      return Math.round(track.scrollLeft / step);
    };

    prev?.addEventListener('click', () => {
      scrollToIndex(currentIndex() - advanceBy);
    });

    next?.addEventListener('click', () => {
      scrollToIndex(currentIndex() + advanceBy);
    });

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.dataset.index || '0', 10);
        scrollToIndex(index);
      });
    });

    let scrollRaf = null;
    track.addEventListener('scroll', () => {
      if (scrollRaf) cancelAnimationFrame(scrollRaf);
      scrollRaf = requestAnimationFrame(() => {
        setActive(currentIndex());
      });
    }, { passive: true });

    // Keyboard navigation on carousel
    carousel?.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        scrollToIndex(currentIndex() + 1);
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        scrollToIndex(currentIndex() - 1);
      }
    });

    setActive(0);
  };

  const boot = () => {
    document.querySelectorAll('[data-gh-section]').forEach((section) => {
      if (section.__ghInit) return;
      section.__ghInit = true;
      init(section);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify section rendering API — re-init on section load
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-gh-section]');
    if (section && !section.__ghInit) {
      section.__ghInit = true;
      init(section);
    }
  });
})();
